export default function StatusBadge({ status }) {
  if (!status) {
    return (
      <span className="status-badge pending" data-testid="status-badge-pending">
        <span className="w-2 h-2 rounded-full bg-slate-400" />
        Pending
      </span>
    );
  }

  const statusMap = {
    Yes: { label: 'Compliant', className: 'compliant', color: 'bg-status-compliant' },
    No: { label: 'Non-Compliant', className: 'non-compliant', color: 'bg-status-noncompliant' },
    Partially: { label: 'Partial', className: 'partial', color: 'bg-status-partial' },
    'N.A': { label: 'N/A', className: 'na', color: 'bg-status-na' },
  };

  const statusInfo = statusMap[status] || statusMap.Yes;

  return (
    <span className={`status-badge ${statusInfo.className}`} data-testid={`status-badge-${statusInfo.className}`}>
      <span className={`w-2 h-2 rounded-full ${statusInfo.color}`} />
      {statusInfo.label}
    </span>
  );
}